/**
 * postMessage Bridge für iframe-Parent Kommunikation
 * Sendet Events an die Elternseite (solartechnik-lauckner.de)
 */

// Target Origin für postMessage (Sicherheit!)
const PARENT_ORIGIN = 'https://www.solartechnik-lauckner.de';

// Alternative Origins für Development/Preview
const ALLOWED_PARENT_ORIGINS = [
  'https://www.solartechnik-lauckner.de',
  'https://solartechnik-lauckner.de',
  'http://localhost:3000' // Development
];

/**
 * Prüft ob wir in einem iframe laufen
 */
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    // Wenn Cross-Origin, dann sind wir definitiv in einem iframe
    return true;
  }
}

/**
 * Sendet Button-Click Event an Parent
 * @param {string} buttonId - Eindeutige Button-ID
 * @param {object} metadata - Zusätzliche Metadaten (optional)
 */
export function sendButtonClickEvent(buttonId, metadata = {}) {
  if (!isInIframe()) {
    console.log('[postMessage] Nicht im iframe - Event wird nicht gesendet');
    return;
  }

  try {
    const message = {
      type: 'leadflow-button-click',
      buttonId: buttonId,
      timestamp: new Date().toISOString(),
      ...metadata
    };

    window.parent.postMessage(message, PARENT_ORIGIN);
    console.log('[postMessage] Button-Click Event gesendet:', message);
  } catch (error) {
    console.error('[postMessage] Fehler beim Senden des Button-Click Events:', error);
  }
}

/**
 * Sendet Redirect-Request an Parent
 * @param {string} url - Ziel-URL für Redirect
 */
export function sendRedirectEvent(url) {
  if (!isInIframe()) {
    console.log('[postMessage] Nicht im iframe - Redirect lokal:', url);
    window.location.href = url;
    return;
  }

  try {
    const message = {
      type: 'redirect',
      url: url,
      timestamp: new Date().toISOString()
    };

    window.parent.postMessage(message, PARENT_ORIGIN);
    console.log('[postMessage] Redirect Event gesendet:', message);
  } catch (error) {
    console.error('[postMessage] Fehler beim Senden des Redirect Events:', error);
  }
}

/**
 * Sendet Lead-Submission Event an Parent (bereits vorhanden, hier dokumentiert)
 * @param {string} formType - Typ des Formulars
 * @param {object} data - Zusätzliche Daten
 */
export function sendLeadSubmissionEvent(formType = 'fixed-contact', data = {}) {
  if (!isInIframe()) {
    console.log('[postMessage] Nicht im iframe - Lead-Submission Event nicht gesendet');
    return;
  }

  try {
    const message = {
      type: 'leadform-submitted',
      consent: true,
      formType: formType,
      timestamp: new Date().toISOString(),
      ...data
    };

    window.parent.postMessage(message, PARENT_ORIGIN);
    console.log('[postMessage] Lead-Submission Event gesendet:', message);
  } catch (error) {
    console.error('[postMessage] Fehler beim Senden des Lead-Submission Events:', error);
  }
}

/**
 * Sendet custom Event an Parent
 * @param {string} eventType - Event-Typ
 * @param {object} data - Event-Daten
 */
export function sendCustomEvent(eventType, data = {}) {
  if (!isInIframe()) {
    console.log('[postMessage] Nicht im iframe - Custom Event wird nicht gesendet');
    return;
  }

  try {
    const message = {
      type: eventType,
      timestamp: new Date().toISOString(),
      ...data
    };

    window.parent.postMessage(message, PARENT_ORIGIN);
    console.log('[postMessage] Custom Event gesendet:', message);
  } catch (error) {
    console.error('[postMessage] Fehler beim Senden des Custom Events:', error);
  }
}

/**
 * Sendet Scroll-to-Top Request an Parent
 * Wird beim Öffnen des Modal-Formulars aufgerufen
 */
export function sendScrollToTopEvent() {
  if (!isInIframe()) {
    console.log('[postMessage] Nicht im iframe - Scroll-to-Top wird nicht gesendet');
    return;
  }

  try {
    const message = {
      type: 'scroll-to-top',
      timestamp: new Date().toISOString()
    };

    window.parent.postMessage(message, PARENT_ORIGIN);
    console.log('[postMessage] Scroll-to-Top Event gesendet');
  } catch (error) {
    console.error('[postMessage] Fehler beim Senden des Scroll-to-Top Events:', error);
  }
}

// Export für Nutzung in Komponenten
export default {
  isInIframe,
  sendButtonClickEvent,
  sendRedirectEvent,
  sendLeadSubmissionEvent,
  sendCustomEvent
};
